module.exports = __webpack_public_path__ + "img/202001-1.39fa249d.png";